import {PlaySpace} from './playSpace';
import {Player} from "./player";
import {PlayerEventInfo} from "./playerEventInfo";

export interface EventAttendance {
  confirmed?: number;
  declined?: number;
  notResponded?: number;
  notInvited?: number;
  max?: number;
  full?: boolean;
  isFull?: boolean;
}

export interface EventParticipation {
  status?: string;
  jersey?: string;
  teamMemberType?: string;
  modificationDate?: Date | string;
  source?: string;
}

export class Event {
  chat?: {id: string; name?: string};

  id: string;
  originalEventId: string;

  name: string;
  manager: Player;

  active: boolean;
  rulebook: string;

  locationId: string;
  locationName: string;
  playSpace: PlaySpace;
  openToPublic: boolean = false;

  nextOccurrenceTimestamp: Date;
  nextOccurrence: string;
  nextOccurrenceTimestampZone: string;
  recurringType: string;

  season1StartDate: Date;
  season2StartDate: Date;
  seasonMode: "YEARLY" | "INFINITE" | "CUSTOM";
  seasonStartDates: Date[];

  teamWhite: boolean;
  whiteScore: number;
  blackScore: number;
  gameResults: EventGameResult[] = Array<EventGameResult>();
  wonLostDrewNothing: string;

  imageUrl: string;

  playerEventInfos: PlayerEventInfo[] = Array<PlayerEventInfo>();
  participants: Player[] = Array<Player>();
  attendance: EventAttendance;
  participation: EventParticipation;

  sosUsed: boolean;
  teammateSosUsed: boolean;
  sos: boolean;
  confirmedCount: number;
  maxPlayers: number;

  note: string;
  access?: { member: boolean; requestPending: boolean; canRequestJoin: boolean; canLeave: boolean };
  managerHome?: {
    phase: string; missingPlayers: number; confirmedCount: number; maxPlayers: number;
    announcementRecipientCount: number;
    inviteAudiences: { type: string; eligibleCount: number }[];
    sosActions: { type: string; status: string; unavailableReason?: string }[];
    launchCampaign?: RecruitmentCampaign;
    importantChanges: { id: string; type: string; playerId?: string; playerName?: string; createdAt?: string }[];
  };
  activitySummary?: { playedMatchCount?: number; recentMatchCount?: number; rosterCount?: number; averageConfirmedPlayers?: number; createdAt?: string; lastPlayedAt?: string };
  connectionSummary?: { firstDegreeCount?: number; secondDegreeCount?: number; thirdDegreeCount?: number; previewPlayers?: { player: Player; degree: string; sharedMatchCount?: number }[] };


  sendingNotificationsInProgress: boolean = false;
  currentPlayerInviteStatus: string;
  participates: boolean;

  viewedByManager: boolean = false;
  viewedByPlayer: boolean = false;
  viewedByCandidate: boolean = false;

  incompleteSetup: boolean;
  setupCompletedAt: Date;
  managerLastViewedAt: Date;
  cancelled: boolean;
  cancelledAt: Date;
  cancelledByPlayerId: string;
  cancelReason: string;

  newCandidatesFound: boolean = false;

  historyEvent = false;
}

export interface EventGameResult {
  id?: string;
  roundNumber: number;
  whiteScore: number;
  blackScore: number;
  whitePlayerIds: string[];
  blackPlayerIds: string[];
}

export class EventRecurringType {
  DAILY: string = "DAILY";
  WEEKLY: string = "WEEKLY";
  MONTHLY: string = "MONTHLY";
  ONE_OFF: string = "ONE_OFF";
}

export interface BalanceTeamsPlayerResult {
  playerId: string;
  nickName: string;
  jersey: string;
  averageOffence: number;
  averageDefence: number;
  offenceRatingCount?: number;
  offenceRatingSum?: number;
  defenceRatingCount?: number;
  defenceRatingSum?: number;
  offenceFallbackUsed?: boolean;
  defenceFallbackUsed?: boolean;
}

export interface BalanceTeamsCalculation {
  confirmedPlayersCount: number;
  whiteTeamSize: number;
  blackTeamSize: number;
  whiteOffenceAverage: number;
  whiteDefenceAverage: number;
  whiteCombinedAverage: number;
  blackOffenceAverage: number;
  blackDefenceAverage: number;
  blackCombinedAverage: number;
  oddPlayerCount: boolean;
  fallbackRatingUsed: boolean;
}

export interface BalanceTeamsResult {
  eventId: string;
  whiteTeam: BalanceTeamsPlayerResult[];
  blackTeam: BalanceTeamsPlayerResult[];
  offenceDifference: number;
  defenceDifference: number;
  totalDifference: number;
  algorithm: string;
  calculation?: BalanceTeamsCalculation;
}

export interface InactiveEventPlayer {
  playerEventInfoId: string;
  playerId: string;
  name: string;
  nickName: string;
  email: string;
  avatar: string;
  status: string;
  teamMemberType: string;
  joinedAt: Date;
  lastPlayedAt: Date;
  inactiveDays: number;
}

export interface RemoveInactivePlayersResult {
  removedPlayerIds: string[];
  missingPlayerIds: string[];
  removedCount: number;
}

export interface EventPlayerBlock {
  playerId: string;
  name: string;
  nickName: string;
  avatar: string;
  blockedAt: Date;
}

export interface EventInviteLinkResponse {
  inviteToken: string;
  invitePath: string;
}

export interface RecruitmentCampaign {
  status: string;
  unavailableReason?: string;
  eligibleRecipientCount?: number;
  recipientCount: number;
  interestedCount: number;
  pendingCandidateCount?: number;
}
